import React from "react";
import { armCadenceLabel } from "../../armTerms";
import { formatRateSheetDate } from "../../ineligibleReasons";

// Small labels after a product's name: the ARM cadence ("5/6 SOFR") and, only
// when the lender's rate sheet is older than the previous business day, its
// date (D19; no banner, 11-02).
export function ProductTags({ product }) {
  const arm = armCadenceLabel(product.arm);
  if (!arm && !product.staleRateSheet) return null;
  return (
    <div className="ppe-tags">
      {arm && <span className="ppe-tag ppe-tag-arm">{arm}</span>}
      {product.staleRateSheet && (
        <span className="ppe-tag ppe-tag-old" title="This lender's rate sheet is older than the previous business day.">
          Rate sheet {formatRateSheetDate(product.rateSheetDate)}
        </span>
      )}
    </div>
  );
}
